import script from "./campaignsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./campaignsModal.vue?vue&type=script&setup=true&lang=js"

import "./campaignsModal.vue?vue&type=style&index=0&id=2e35f6d8&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e35f6d8"]])

export default __exports__